export default from './comment-bar';



// WEBPACK FOOTER //
// ./app/components/comment-bar/index.js